import { FeatureCollection } from 'geojson'
import { Image } from './Constants'
import { SupportedContentBooster } from './Hazards'
import { OrganizationOverview } from './Organization'

export enum CSOScope {
    LOCAL = 'local',
    NATIONAL = 'national',
}

export interface CSOResponse {
    // Keeping CSO list as "alternatives" to maintain legacy support
    alternatives: CrisisSupportOption[]
    date_modified: string
}
export interface CrisisSupportOption {
    id: number
    title: string
    priority: number
    subheader: string | null
    phone: string | null
    is_text_line: boolean
    link: string | null
    hours: string | null
    always_available: boolean
    who_they_help: string
    details: string | null
    examples: string
    filters: SupportedContentBooster[]
    icon: Image | null
    hazards: number[]
    scope: CSOScope
    creator?: OrganizationOverview // for localized content
    area_override?: FeatureCollection // for localized content
    local?: boolean // for local content
}
